<template>
    <div class="flats-items" v-if="flatsArr != null">
        <div class="flat-item" v-for="(item, index) in flatsArr"  :key="item.id">
            <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" target="_blank">
                <div class="item-default item-img" v-if="item != null && item.id != null">
                    <div class="img-in" v-if="item.images.length > 0">
                        <img :src="ucoCRMurl + '/rest/prices/getImage?imageId=' + pic.id"  alt="" v-for="pic in item.images" v-if="pic.typeCode == '1'">
                        <!-- <img v-lazy="'https://bazis-online.kz/crmc/rest/prices/getImage?imageIdasdasdasd=' + pic.id"  alt="" v-for="pic in item.images" v-if="pic.typeCode == '1'"> -->
                    </div>
                    <div class="btns-active">
                        <div class="btn-item btn-to-favorite">
                            <a href="#" class="favorite-link btn-link" @click.prevent="sendToFavorite(item.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.id)}">
                                <!-- <svgIcon name="star" class="icon-star"/> -->
                                <svgIcon name="star-sales" class="icon-star"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="item-desc">
                    <div class="item-title">
                        <span class="rooms">{{item.rooms}}</span> {{flatsPage.flats_cards_info.flat_name}}, <span>{{item.area}} <b>м²</b></span>
                    </div>
                    <div class="item-info">
                        <ul>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_object_name}}
                                </div>
                                <div class="right">
                                    {{item.complexName.replace(/['"]+/g, '')}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_size}}
                                </div>
                                <div class="right">
                                    {{item.area}} <span>м²</span>
                                </div>
                            </li>
                            <li class="price" v-if="item.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_price}} м²
                                </div>
                                <div class="right">
                                    <span>от</span> {{getNumber(item.meterPrice)}} <span>тг.</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_floor}}
                                </div>
                                <div class="right">
                                    {{item.floor}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_flat_number}}
                                </div>
                                <div class="right">
                                    {{item.number}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_bloom}}
                                </div>
                                <div class="right">
                                    {{getNumbersOfString(item.blockName)}}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'flats-item',
        props: ['flatsArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            ucoCRMurl: 'loadUrlCRMuco',
        }),
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
            sendToFavorite(id) { // Добавление квартиры в избранное
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('favorite_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('favorite_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            checkProjectFavorite(id) {
                var items = localStorage.getItem('favorite_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // console.log(this.flatsArr)
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items.scss';
    // @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-respond.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>